import { useSelector } from 'react-redux';

import { ActiveTableSelector, useActiveTableSelector } from '../../../../../element/table/store/hotTableStoreHooks';
import {
    selectActiveTableCommonTextAlignment,
    selectActiveTableCommonVerticalAlignment,
    selectIsActiveTableAlignmentToolDisabled,
} from '../../../../../element/table/store/selectors/activeHotTableSelectors';
import { userLanguagePreferenceSelector } from '../../../../../user/currentUserSelector';
import { useMemo } from 'react';

type UseTableCellAlignmentToolStateReturn = {
    commonTextAlignment: string | undefined;
    commonVerticalAlignment: string | undefined;
    isDisabled: boolean;
};

const useTableCellAlignmentToolState = (): UseTableCellAlignmentToolStateReturn => {
    const locale = useSelector(userLanguagePreferenceSelector);
    const selectCommonTextAlignment = useMemo<ActiveTableSelector<string | undefined>>(
        () => (activeTable) => selectActiveTableCommonTextAlignment(activeTable, { locale }),
        [locale],
    );
    const commonTextAlignment = useActiveTableSelector(selectCommonTextAlignment);
    const commonVerticalAlignment = useActiveTableSelector(selectActiveTableCommonVerticalAlignment);
    const isDisabled = useActiveTableSelector(selectIsActiveTableAlignmentToolDisabled);

    return {
        commonTextAlignment,
        commonVerticalAlignment,
        isDisabled,
    };
};

export default useTableCellAlignmentToolState;
